import $ from 'jquery';
import BlockSort from './block-sort';
import { campaignTemplateData, giftTemplateData, bannersTemplateData } from '../data/sort-item-data';

export default class SortItemsAssign {
  constructor() {
    this.allSortListSortInit = '';
    this.selectedsortingListSortInit = '';
    this.$searchInput = $('.js__sort-filter');
    this.sortItemTemplate = $('.js__sort-management');
    this.deleteButton = $('.js__delete-prototype').find('button');
    this.moveButton = $('.js__move-prototype').find('.js__sort-move-handle');
    this.searchResults = null;
    this.data = [];

    this.$searchInput.search({
      minCharacters: 3,
      searchDelay: 500,
      showNoResults: false,
      searchOnFocus: false,
      apiSettings: {
        url: `${this.$searchInput.data('search-url')}?phrase={query}`,
        onResponse: res => {
          this.searchResults = res;
          this.filterResults(res);
        },
        beforeSend: settings => {
          $('.js__sort-filter-segment').addClass('loading');
          this.$searchInput.find('input').blur();
          return settings;
        },
      },
    });

    this.selection = [];
    this.init();
  }

  filterResults(res) {
    const $allSortList = $('.js__all-sort-list');
    const addedValues = this.getAddedValues();
    $('.no-results').remove();
    if (addedValues.length) {
      this.data = Object.values(res).filter(item => !addedValues.includes(item.id));
    } else {
      this.data = Object.values(res);
    }
    this.renderList(this.data);

    if (!Object.keys(this.data).length) {
      $allSortList.append('<div class="no-results">No results</div>');
    }
    $('.js__sort-filter-segment').removeClass('loading');
  }

  getAddedValues() {
    return $.makeArray($('.js__selected-sort-item-list .js__sort-item')).map(item => $(item).data('id'));
  }

  renderList(data) {
    const $selectedSortItems = $('.js__selected-sort-item-list .item');
    const $allSortList = $('.js__all-sort-list');

    $allSortList.empty();
    data.forEach(item => {
      if (!$selectedSortItems.filter(`[data-id="${item.id}"]`).length) {
        const $sortItem = $(this.sortItemTemplate.data('prototype').replace(/__name__/g, item.id));
        let $sortBlockPrototype = $('.js__sort-item-prototype').clone();

        if (item.enabled || item.active) {
          $sortBlockPrototype.find('.js__is-sort-item-enabled').remove();
        } else {
          $sortBlockPrototype.find('.js__is-sort-item-disabled').remove();
        }

        if (!item.isVisibleToSegmentsOnly) {
          $sortBlockPrototype.find('.js__is-visible-to-segment-only').remove();
        }

        const $availabilityElement = $sortBlockPrototype.find('.js__availability');
        if ($availabilityElement.data('visible-to-type') !== item.type) {
          $availabilityElement.remove();
        }

        if (item.accessibleBeforeLogin !== undefined) {
          if (item.accessibleBeforeLogin) {
            $sortBlockPrototype.find('.js__no-access-before-login').remove();
          } else {
            $sortBlockPrototype.find('.js__access-before-login').remove();
          }
        }
        let sortBlockPrototypeHtml = $sortBlockPrototype.html();

        let dataTemplate;
        const searchDataType = this.$searchInput.data('type');
        if (searchDataType === 'campaign') {
          dataTemplate = campaignTemplateData(item);
        } else if (searchDataType === 'gifts') {
          dataTemplate = giftTemplateData(item);
        } else if (searchDataType === 'banners') {
          dataTemplate = bannersTemplateData(item);
        }

        $(dataTemplate).each((key, item) => {
          const value = item.value ? item.value.toString() : '-';
          sortBlockPrototypeHtml = sortBlockPrototypeHtml.replace(new RegExp(item.replaceValue, 'g'), value);
        });

        $sortBlockPrototype = $(`<div></div>`).append($(sortBlockPrototypeHtml));
        const $prototypeImage = $sortBlockPrototype.find('.js__prototype-image');

        if ($prototypeImage.data('src')) {
          $prototypeImage.attr('src', $prototypeImage.data('src'));
        }

        sortBlockPrototypeHtml = $sortBlockPrototype.html();
        $sortItem.find('select').val(item.id);
        $sortItem.find('input, select').attr('disabled', true);
        $(`<div class="sort-item js__sort-item" data-id="${item.id}"></div>`)
          .append($sortItem, sortBlockPrototypeHtml)
          .appendTo($allSortList);
        $('.sort-item').find('.js__action-dropdown-init').dropdown();
      }
    });
  }

  moveAction($el) {
    const id = $el.data('id');
    const $selectedSortItems = $('.js__selected-sort-item-list .sort-item');
    const sortItemsId = [];
    $selectedSortItems.each((index, item) => sortItemsId.push($(item).data('id')));
    const $selectedSortList = $('.js__selected-sort-item-list');

    if (!sortItemsId.includes(id)) {
      const deleteBtnTemplate = this.deleteButton.clone();
      const moveBtnTemplate = this.moveButton.clone();
      $el.find('.block-action-group button').replaceWith(deleteBtnTemplate);
      $el.find('.content').before(moveBtnTemplate);
      $el.detach().appendTo('.js__selected-sort-item-list');
      this.reorderItemInputs($selectedSortList);

      $selectedSortList.find('.js__sort-item').each((item, index) => {
        $(index).find('input[type="number"]').val(item);
      });
      $el.find('input, select').attr('disabled', false);
      $($selectedSortList).removeClass('empty');
    } else {
      $('.js__duplicate-in-list-modal').modal('show');
    }
  }

  showError(message, item) {
    item.append(message);
  }

  deleteAction(el) {
    const $el = $(el);
    const url = $el.data('url');
    const $selectedSortList = $('.js__selected-sort-item-list');

    if (url) {
      this.sortItemTemplate.addClass('loading');
      $.get(url)
        .fail(() => console.log('error'))
        .done(() => {
          $el.closest('.sort-item').remove();
          this.reorderItemInputs($selectedSortList);
          if (this.searchResults) {
            this.filterResults(this.searchResults);
          }
        })
        .always(() => {
          this.sortItemTemplate.removeClass('loading');
          this.selectedsortingListSortInit.updateInputs($selectedSortList.find('.js__sort-item'));
          if (!$selectedSortList.find('.js__sort-item').length) {
            $selectedSortList.addClass('empty');
          }
        });
    } else {
      $el.closest('.sort-item').remove();
      if (this.searchResults) {
        this.filterResults(this.searchResults);
      }
      if (!$selectedSortList.find('.js__sort-item').length) {
        $selectedSortList.addClass('empty');
      }
    }
  }

  reorderItemInputs($node) {
    $node.find('.sort-item').each((index, item) => {
      const $input = $(item).find('input:not(.search)');
      const $select = $(item).find('select');
      const regId = /_\d+_/;
      const regName = /\d+/;
      const inputId = $input.attr('id').replace(regId, `_${index}_`);
      const inputName = $input.attr('name').replace(regName, `${index}`);
      const selectId = $select.attr('id').replace(regId, `_${index}_`);
      const selectName = $select.attr('name').replace(regName, `${index}`);

      $input.attr('id', inputId);
      $input.attr('name', inputName);
      $select.attr('id', selectId);
      $select.attr('name', selectName);
    });
  }

  bindEvents() {
    const $body = $('body');
    $body.on('click', '.js__action-delete-sort-item', e => this.deleteAction(e.currentTarget));
    $body.on('click', '.js__add-sort-item-to-list', e => this.moveAction($(e.currentTarget).parents('.js__sort-item')));

    $('.js__sort-item').find('.js__action-dropdown-init').dropdown();
    $('.js__submit-sort-assign-btn').on('click', () => {
      $('.js__sort-submit-form').find('input, select').attr('disabled', false);
      $('.js__sort-submit-form').submit();
      this.sortItemTemplate.addClass('loading');
    });
  }

  initSortGroups() {
    this.allSortListSortInit = new BlockSort($('.js__all-sort-list').get(0), {
      handle: '.js__sort-move-handle',
      group: {
        name: 'sortList',
        put: false,
      },
      invertSwap: true,
      animation: 100,
      sort: false,
    });

    this.selectedsortingListSortInit = new BlockSort($('.js__selected-sort-item-list').get(0), {
      group: 'sortList',
      handle: '.js__sort-move-handle',
      animation: 100,
      onAdd: event => {
        this.selectedsortingListSortInit.updateInputs(event.target);
        $(event.target).removeClass('empty');
      },
    });
  }

  init() {
    this.initSortGroups();
    this.bindEvents();
  }
}
